var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_1023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4201 9.77841C22.5602 10.0635 22.6527 10.3688 22.6941 10.6826L23.4598 22.0674L23.8398 27.7897C23.8438 28.3781 23.9361 28.9628 24.1138 29.5248C24.5729 30.6152 25.6772 31.3082 26.8787 31.2599L45.1862 30.0625C45.9789 30.0494 46.7445 30.3459 47.3144 30.8868C47.7893 31.3374 48.0959 31.927 48.1926 32.5611L48.225 32.9462C47.4674 43.4367 39.7627 52.1865 29.294 54.4452C18.8253 56.7039 8.09012 51.9325 2.91695 42.7217C1.42556 40.0457 0.494038 37.1044 0.17705 34.0704C0.0446285 33.1723 -0.0136799 32.2651 0.00269287 31.3577C-0.0136563 20.1108 7.99554 10.3874 19.2069 8.04327C20.5562 7.83317 21.8791 8.5475 22.4201 9.77841Z",
    fill: "#F25D27"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.8921 0.00225276C42.4318 0.321274 52.9709 9.33845 54.9996 21.4838L54.9803 21.5734L54.9249 21.7038L54.9326 22.0615C54.9039 22.5354 54.7209 22.9914 54.4055 23.3598C54.077 23.7435 53.6282 24.0049 53.134 24.1063L52.8326 24.1475L31.7104 25.5161C31.0079 25.5854 30.3083 25.359 29.7859 24.8929C29.3505 24.5045 29.0721 23.9802 28.9934 23.4154L27.5757 2.32393C27.551 2.25261 27.551 2.17529 27.5757 2.10397C27.595 1.5226 27.851 0.97306 28.2862 0.578131C28.7215 0.183204 29.2999 -0.024201 29.8921 0.00225276Z",
    fill: "#F25D27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_1023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.26797951d35f5950ab24f8a81c3deca4.svg";
export { ForwardRef as ReactComponent };